import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import StepProgressBar from '@/components/general/step-indicator';
import { isPathEk } from '@/utils/routes';
import { ekDomain, ROUTES } from '@/configs/constants';
import AnimateButton from '@/components/general/button-custom/AnimateButton';

export default observer(function RegisterStep3() {
    // hooks
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const { state } = useLocation();
    const email = state?.email || '';
    const isEk = isPathEk(pathname);

    const getUrlSearchByCurrent = (): string => {
        return isEk ?
            `/${ekDomain}/${ROUTES.locationCurrentList.hrefEK}` :
            `/${ROUTES.locationCurrentList.href}`;
    };
    const getUrlSearchByPrefectures = (): string => {
        return isEk ?
            `/${ekDomain}/${ROUTES.locationList.hrefEK}` :
            `/${ROUTES.locationList.href}`;
    };

    return (
        <>
            {/* Title */}
            <h3 className='title-1 text-center mb-3'>
                {t('words_title.register_account')}
            </h3>

            {email && (
                <>
                    <div className='pt-6'>
                        <StepProgressBar
                            startingStep={2}
                            labelClass='text-fs-mid13'
                            wrapperClass='w-full'
                            steps={[
                                {
                                    label: t('words_title.register_page.step_1'),
                                    name: 'register_page.step_1'
                                },
                                {
                                    label: t('words_title.register_page.step_2'),
                                    name: 'register_page.step_2'
                                },
                                {
                                    label: t('words_title.register_page.step_3'),
                                    name: 'register_page.step_3'
                                }
                            ]}
                        />
                    </div>
                    <div className='h-8 w-full'></div>
                </>
            )}

            {/* Text content */}
            <div className='mt-3 grid gap-5'>
                <h4 className='text-fs-mid20 font-semibold text-center'>
                    {
                        isEk ?
                            (
                                <>ベストBikeキックボードへようこそ！</>
                            ) :
                            (
                                <>ベストBikeへようこそ！</>
                            )
                    }
                </h4>

                <p className='text-fs-mid14 text-center'>
                    {email && (
                        <>
                            アカウントの作成が完了いたしました。
                            <br />
                        </>
                    )}
                    {
                        isEk ?
                            (
                                <>早速電動キックボードのレンタルをする場合、下記から拠点を選んでご予約下さい。</>
                            ) :
                            (
                                <>早速バイクのレンタルをする場合、下記から拠点を選んでご予約下さい。</>
                            )
                    }
                </p>
            </div>

            {
                isEk ?
                    (
                        <div className='flex justify-center mt-8'>
                            <Link
                                to={getUrlSearchByPrefectures()}
                                className='inline-block w-full xsm:w-[280px]'
                            >
                                <AnimateButton
                                    contentComp='都道府県から拠点を探す'
                                    parentClassName='h-[48px]'
                                    textClassName='text-fs-mid13'
                                />
                            </Link>
                        </div>
                    ) :
                    (
                        <div className='flex flex-col sm:flex-row gap-3 xsm:gap-4 md:gap-6 justify-center items-center mt-8'>
                            <Link
                                to={getUrlSearchByCurrent()}
                                className='inline-block w-full xsm:w-[230px]'
                            >
                                <AnimateButton
                                    outline
                                    contentComp='現在地から拠点を探す'
                                    parentClassName='h-[48px]'
                                    className='px-[20px] py-[10px]'
                                    textClassName='text-fs-mid13'
                                />
                            </Link>
                            <Link
                                to={getUrlSearchByPrefectures()}
                                className='inline-block w-full xsm:w-[230px]'
                            >
                                <AnimateButton
                                    contentComp='都道府県から拠点を探す'
                                    parentClassName='h-[48px]'
                                    className='px-[20px] py-[10px]'
                                    textClassName='text-fs-mid13'
                                />
                            </Link>
                        </div>
                    )
            }
        </>
    );
});
